import { useRecoilState, useRecoilValue } from 'recoil';
import cloneDeep from 'lodash/cloneDeep';
import MenuIcon from '@mui/icons-material/Menu';
import WrapTextIcon from '@mui/icons-material/WrapText';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';

import * as K from 'common/constants';
import { useResetScrollState } from 'hooks/useResetScrollState';

import { displayModeSelector, settingsState } from 'components/common/Managers/SettingsManager.state';
import ToggleIconButtonGroup from 'components/common/ToggleIconButtonGroup/ToggleIconButtonGroup';

const buttons = [
  {
    displayMode: K.DISPLAY_MODE.LINES,
    icon: <MenuIcon />,
    tooltip: 'Single-line rows',
  },
  {
    displayMode: K.DISPLAY_MODE.WRAPPED,
    icon: <WrapTextIcon />,
    tooltip: 'Wrapping rows',
  },
  {
    displayMode: K.DISPLAY_MODE.TABLE,
    icon: <ViewModuleOutlinedIcon />,
    tooltip: 'Table',
  },
];

const LogLinesToolbarButtons = () => {
  const selectedDisplayMode = useRecoilValue(displayModeSelector);
  const [settings, setSettings] = useRecoilState(settingsState);
  const resetScrollState = useResetScrollState();

  return (
    <ToggleIconButtonGroup
      buttons={buttons.map(({ displayMode, ...button }) => ({
        ...button,
        active: selectedDisplayMode === displayMode,
        key: displayMode,
        onClick: () => {
          if (selectedDisplayMode === displayMode) {
            return;
          }
          const newSettings = cloneDeep(settings);
          newSettings.displayMode = displayMode;
          setSettings(newSettings);
          resetScrollState();
        },
      }))}
      size="sm"
    />
  );
};

export default LogLinesToolbarButtons;
